import React from 'react';
const pains = [{
  emoji: '😰',
  title: 'Pianificazione Costante delle Sessioni',
  description: 'Passi ore ogni settimana a creare sequenze, adattare i livelli di pratica e organizzare sessioni per allievi con obiettivi e capacità completamente diverse.'
}, {
  emoji: '⚠️',
  title: 'Paura di Chiedere Troppo... O Troppo Poco',
  description: 'Ti chiedi continuamente se i tuoi allievi si stanno impegnando abbastanza per migliorare, o se stai chiedendo troppo rischiando di scoraggiarli o affaticarli.'
}, {
  emoji: '📚',
  title: 'Informazioni Ovunque',
  description: 'Trovi metodi di yoga, tecniche di movimento e consigli da ogni parte, ma nulla è organizzato in un sistema completo che tu possa seguire con sicurezza e professionalità.'
}, {
  emoji: '😩',
  title: 'Esaurimento Mentale',
  description: "Tra la pianificazione delle sessioni, il monitoraggio dei progressi, l'adattamento dei programmi e le domande degli allievi, rimane pochissimo tempo per concentrarti davvero su ciò che conta: aiutarli a trasformarsi."
}];
export function PainSection() {
  return <section className="py-16 px-4 bg-white border-b-8 border-brand-light" data-id="element-113">
      <div className="max-w-4xl mx-auto" data-id="element-114">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-center text-brand-dark mb-6 tracking-tight uppercase" data-id="element-115">
          LO RICONOSCI?
        </h2>

        <p className="text-base sm:text-lg text-brand-dark font-medium text-center mb-12 max-w-3xl mx-auto leading-relaxed" data-id="element-116">
          Ami insegnare yoga, ma la pianificazione ti consuma l'intera
          settimana? Se sei un'insegnante di yoga, coach del benessere,
          istruttrice di yoga terapeutico o professionista che lavora con
          adulti, probabilmente conosci almeno una di queste situazioni:
        </p>

        <div className="grid sm:grid-cols-2 gap-6" data-id="element-117">
          {pains.map((pain, i) => <div key={i} className="bg-brand-light p-6 sm:p-8 rounded-xl border-2 border-brand-green/20 shadow-lg flex flex-col items-center text-center sm:items-start sm:text-left sm:flex-row gap-4 hover:border-brand-green transition-colors" data-id="element-118">
              <div className="text-4xl shrink-0 bg-white w-16 h-16 rounded-full flex items-center justify-center shadow-md border border-gray-100" data-id="element-119">
                {pain.emoji}
              </div>
              <div data-id="element-120">
                <h3 className="text-lg font-black text-brand-dark mb-2 uppercase" data-id="element-121">
                  {pain.title}
                </h3>
                <p className="text-brand-dark/80 text-sm font-medium leading-relaxed" data-id="element-122">
                  {pain.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}